import api from './httpClient';

export const loginUser = async (email, password) => {
  const res = await api.post('/api/auth/login', { email, password });
  return res.data?.data;
};
